import React, { Fragment, useEffect, useState } from 'react'
import { Button, InputGroup, Row, useOverlay, DangerButton } from '@fs/zion-ui'
import { ContentDelete } from '@fs/zion-icon/dist/cjs/icons'
import ConfirmQueueOpDialogOverlay from './compactMessagesList/ConfirmQueueOpDialogOverlay'

export default function TopOperations({ queueState, queueActions, disabled }) {
  const [buttonCallback, setButtonCallback] = useState(null)
  const overlay = useOverlay()
  const checkedCount = Object.keys(queueState.selectedCheckboxes || {}).length
  const { isOpen, transitioning } = overlay

  useEffect(() => {
    if (!isOpen && !transitioning) {
      queueActions.setQueueState((prevState) => ({
        ...prevState,
        confirmDialogOpen: false,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, transitioning])

  function confirmTopOperation(bc) {
    setButtonCallback(() => bc)
    if (checkedCount > queueState.checkboxConfirmLimit) {
      overlay.open()
      queueActions.setQueueState((prevState) => ({
        ...prevState,
        confirmDialogOpen: true,
      }))
    } else {
      queueActions.pressTopButton(bc)
    }
  }

  return (
    <>
      <InputGroup>
        <Row alignX="end">
          {queueState.topButtons.map((topButton) => (
            <Fragment key={topButton.buttonText}>
              {topButton.buttonText === 'Delete' ? (
                <DangerButton
                  Icon={ContentDelete}
                  disabled={disabled}
                  onClick={() => confirmTopOperation(topButton.buttonCallback)}
                >
                  {topButton.buttonText}
                </DangerButton>
              ) : (
                <Button
                  emphasis="high"
                  disabled={disabled}
                  onClick={() => confirmTopOperation(topButton.buttonCallback)}
                >
                  {topButton.buttonText}
                </Button>
              )}
            </Fragment>
          ))}
        </Row>
      </InputGroup>
      <ConfirmQueueOpDialogOverlay
        {...overlay}
        onConfirm={() => {
          queueActions.pressTopButton(buttonCallback)
          overlay.close()
          queueActions.setQueueState((prevState) => ({
            ...prevState,
            confirmDialogOpen: false,
          }))
        }}
        onCancel={() => {
          overlay.close()
          queueActions.setQueueState((prevState) => ({
            ...prevState,
            confirmDialogOpen: false,
          }))
        }}
        count={checkedCount}
      />
    </>
  )
}
